const INDEX_ITEMS = [
  { title: '明星私生活', count: '128篇', icon: 'ri-user-star-line' },
  { title: '影视综艺黑幕', count: '96篇', icon: 'ri-tv-2-line' },
  { title: '网红圈层爆料', count: '85篇', icon: 'ri-live-line' },
  { title: '学术造假事件', count: '72篇', icon: 'ri-file-warning-line' },
  { title: '偷税漏税追踪', count: '64篇', icon: 'ri-money-cny-circle-line' },
  { title: '品牌代言风波', count: '58篇', icon: 'ri-close-circle-line' },
  { title: '粉丝圈层动态', count: '52篇', icon: 'ri-group-line' },
  { title: '行业政策解读', count: '45篇', icon: 'ri-government-line' },
  { title: '吃瓜百科知识', count: '38篇', icon: 'ri-book-open-line' },
];

export default function Index() {
  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-950">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50">
            <i className="ri-folder-open-line text-primary-400 mr-2"></i>
            专题索引
          </h2>
          <p className="mt-2 text-sm text-foreground-500">按主题分类浏览，精准定位你想围观的黑料内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {INDEX_ITEMS.map((item, i) => (
            <div
              key={i}
              className="flex items-center gap-4 p-4 rounded-xl bg-background-800/30 border border-background-800/50 hover:border-primary-500/20 hover:bg-background-800/50 transition-all duration-200 cursor-pointer group"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-500/10 text-primary-400 shrink-0">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <div className="min-w-0 flex-1">
                <h3 className="font-heading text-base font-semibold text-foreground-200 group-hover:text-primary-300 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-600 mt-0.5">{item.count} 内容</p>
              </div>
              <i className="ri-arrow-right-s-line text-foreground-700 group-hover:text-primary-400 transition-colors text-lg"></i>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}